import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { RestaurantService } from 'src/app/features/restaurants/services/Restaurant.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import Swal from 'sweetalert2';


export interface DialogData {
  placeOrderTime: number,
  restaurantId: number
}

@Component({
  selector: 'app-restaurant-config',
  templateUrl: './restaurant-config.component.html'
})
export class RestaurantConfigComponent extends DirtyComponent implements OnInit {

  override formGroup!: FormGroup;
  loading = false;
  isSubmitted = false;

  isUpdate: boolean = this.data.placeOrderTime ? true : false;
  constructor(override dialogRef: MatDialogRef<RestaurantConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private formBuilder: FormBuilder,
     translate: TranslateService, private service: RestaurantService) {
      super(translate);
      }

  ngOnInit(): void {
    this.buildForm();
    if (this.isUpdate) {
      this.bindDataToUpdate();
    }
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      placeOrderTime: [1, [
        Validators.required,
        Validators.min(1),
        Validators.max(6)
      ]],
      restaurantId: this.data.restaurantId
    });
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  bindDataToUpdate() {
    this.formGroup.patchValue({
      placeOrderTime: this.data.placeOrderTime,
      restaurantId: this.data.restaurantId
    });
  }


  saveRecord(openNew: boolean = false) {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.loading = true;
      let data = {
        placeOrderTime: Number(this.formGroup.controls['placeOrderTime'].value),
        restaurantId: this.data.restaurantId
      };

      let msg = this.translate.instant('swalMsg.savedsuccessfully');
      if (this.isUpdate) {
        data.placeOrderTime =  Number(this.formGroup.controls['placeOrderTime'].value);
        data.restaurantId = this.data.restaurantId;
        msg = this.translate.instant('swalMsg.updatedsuccessfully');
      }
      this.service.saveRestaurantConfig(data).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: msg,
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        if (openNew) {
          this.formGroup.reset();
        } else {
          this.dialogRef.close(true);
        }
        this.service.refreshList.next(true);
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }

}
